import TestInfo from "../../components/TestInfo/TestInfo";

const ManageTest = () => (
    <div>
        <TestInfo />
    </div>
);

export default ManageTest;
